import { Box, LinearProgress } from "@mui/material";
import React from "react";
import { formatTableTime } from "../../../../utils/dateUtils";

interface TimeProgressBarProps {
  label: string;
  value: number;
  color: string;
  max: number;
}

export const TimeProgressBar: React.FC<TimeProgressBarProps> = ({
  label,
  value,
  color,
  max,
}) => {
  const progress = Math.min((value / max) * 100, 100);

  return (
    <Box sx={{ width: "100%", mb: 0.25 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 0.125,
          px: 0.375,
          py: 0.125,
          bgcolor: `${color}15`,
          borderRadius: "2px 2px 0 0",
          fontSize: "0.6rem",
          color: "text.secondary",
        }}
      >
        <span>{label}</span>
        <span>{formatTableTime(value)}</span>
      </Box>
      <LinearProgress
        variant="determinate"
        value={progress}
        sx={{
          height: 2,
          borderRadius: "0 0 2px 2px",
          bgcolor: "background.paper",
          border: `1px solid ${color}40`,
          borderTop: "none",
          "& .MuiLinearProgress-bar": {
            bgcolor: color,
            borderRadius: "0 0 2px 2px",
          },
        }}
      />
    </Box>
  );
};
